import axiosAPI from 'axios';

const axios = axiosAPI.create({
    baseURL: process.env.REACT_APP_API_URL
})


export { axios };